<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["18"]') }}
      </h1>
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit="handleSubmit"
    >
      <a-form-item
        class="code_form_item"
        :label="mobileTit"
      >
        <a-input
          v-decorator="decorators.mobile"
          :placeholder="mobilePlace"
        />
      </a-form-item>
      <captcha-input
        :label="imgValidTit"
      />
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="telValidPlace"
        />
        <get-code
          class="find-pwd-link ml-16"
          :mobile="form.getFieldValue('mobile')"
          :imgcaptcha="form.getFieldValue('captcha')"
          type="3"
          :is-disabled="false"
          @getRes="sendPhoneCode"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
    <bind-dialog
      ref="bindDialog"
      bind-type="mobile"
      :value="form.getFieldValue('mobile')"
    />
  </div>
</template>

<script>
import BindDialog from '@/components/pc/account/BindDialog'
import getCode from '@/components/pc/GetCode'
import CaptchaInput from '@/components/pc/CaptchaInput.vue'

import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  components: {
    getCode,
    BindDialog,
    CaptchaInput
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators']),
    telValidPlace () {
      return this.$t('message["802"]')
    },
    mobilePlace () {
      return this.$t('message["800"]')
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    imgValidTit () {
      return '图片验证码'
    },
    validTit () {
      return this.$t('message["1433"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/modify', ['bindMobile']),
    ...mapMutations('account/modify', ['setUserid']),
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        // this.$refs.bindDialog.changeLimitDialog(true)
        if (!err) {
          this.form.validateFields(async (err, values) => {
            if (!err) {
              const chain = await this.bindMobile()
              chain.params(values)
                .onSuccess(res => {
                  this.$router.push({ name: 'AccountInfo' })
                })
                .onNetSuccess(raw => {
                  let res = raw.data
                  if (res.error === 104) {
                    this.$refs.bindDialog.changeLimitDialog(true)
                    this.setUserid(res.payload.binduserid)
                  } else {
                    if (res.error) {
                      if (res.error !== 102) {
                        this.$message.warn(res.message || res.payload[0].message)
                      }
                    }
                  }
                })
                .config({ warn: false })
                .setForm(this.form)
                .fetch()
            }
          })
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    },
    sendPhoneCode (res) {
      console.log(res)
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
</style>
